import { ProductType } from 'constants.js';
import { constants } from 'views/Campaign';

const {
  campaignOccurrenceTypes: {
    ON_EVENT,
    SCHEDULED,
    ON_DEMAND,
    INTERNAL_SURVEY_RESPONSE,
    EXTERNAL_SURVEY_RESPONSE
  }
} = constants;

class CurrentTemplate {
  constructor(template, campaign, rule) {
    this.isEventTypeScheduled = template.campaignOccurrenceType === SCHEDULED;
    this.isEventTypeOnDemand = template.campaignOccurrenceType === ON_DEMAND;
    this.isEventTypeResponse = template.campaignOccurrenceType === ON_EVENT;
    this.isEventTypeInternalSurveyResponse =
      template.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE;
    this.isEventTypeExternalSurveyResponse =
      template.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE;

    this.isAlreadyAssigned = rule
      ? rule.communicationTemplateUuid === template.uuid
      : campaign.communicationTemplateUuid === template.uuid;

    this.isTypeSameAsCampaignType = campaign.type === template.type;

    this.isEventTypeSameAsCampaign =
      template.schemaIdentifier === campaign.schemaIdentifier;

    this.isActive = template.active;

    this.isValidListTemplate =
      (template.productType !== ProductType.List &&
        campaign.productType !== ProductType.List) ||
      template.subscriberListId === campaign.subscriberListId;

    this.isPromotionalMatch = campaign.promotional ? template.promotional === true : true;

    this.isSurveyResponseTemplate = template.surveyResponseTemplate === true;
  }
}

export default (templates = [], thisCampaign, rule) => {
  let results = [];
  if (thisCampaign.campaignOccurrenceType === ON_DEMAND) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeOnDemand &&
        currentTemplate.isTypeSameAsCampaignType &&
        currentTemplate.isEventTypeSameAsCampaign &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isValidListTemplate &&
        currentTemplate.isPromotionalMatch
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === SCHEDULED) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeScheduled &&
        currentTemplate.isTypeSameAsCampaignType &&
        currentTemplate.isEventTypeSameAsCampaign &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isPromotionalMatch
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeInternalSurveyResponse &&
        currentTemplate.isEventTypeSameAsCampaign &&
        currentTemplate.isTypeSameAsCampaignType &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isValidListTemplate &&
        currentTemplate.isPromotionalMatch &&
        currentTemplate.isSurveyResponseTemplate
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeExternalSurveyResponse &&
        currentTemplate.isEventTypeSameAsCampaign &&
        currentTemplate.isTypeSameAsCampaignType &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isValidListTemplate &&
        currentTemplate.isPromotionalMatch &&
        currentTemplate.isSurveyResponseTemplate
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === ON_EVENT) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeResponse &&
        currentTemplate.isEventTypeSameAsCampaign &&
        currentTemplate.isTypeSameAsCampaignType &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isPromotionalMatch
      );
    });
  }

  return results;
};
